import React, { FC } from "react";
import { useStaticQuery, graphql } from "gatsby";

interface SeoProps {
  title: string;
  description?: string;
  featuredImageUrl?: string;
  includeTitlePostfix?: boolean;
}

const Seo: FC<SeoProps> = ({ description = "", title, featuredImageUrl, includeTitlePostfix = true }) => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          author
        }
      }
    }
  `);

  const metaDescription = description || site.siteMetadata.description;
  const siteTitle = site.siteMetadata?.title;

  return (
    <>
      <title>{`${title} ${includeTitlePostfix ? ` | ${siteTitle}` : ""}`}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      {featuredImageUrl && (
        <>
          <meta property="og:image" content={featuredImageUrl} id="ogimage" />
          <meta property="og:image:secure_url" content={featuredImageUrl} id="ogimagesecure" />
        </>
      )}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={site.siteMetadata?.author || ``} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
    </>
  );
};

Seo.defaultProps = {
  description: "",
};

export default Seo;
